import { Select } from "melco-ui"
import { useGetSupplierProductsBySupplierType } from "../../hooks/supplierproducts/useGetSupplierProductsBySupplierType";
import { useTranslation } from "react-i18next";
import { MACHINES } from "../../helper/suppliers";


type MachinesSelectProps = {
    mode?: string;
    value?: string | string[];
    disabled?: boolean;
    onChange?: (value: string | string[]) => void;
}

export const MachinesSelect: React.FC<MachinesSelectProps> = ({
    mode,
    value,
    disabled,
    onChange
}) => {

    let { data } = useGetSupplierProductsBySupplierType(MACHINES);

    //console.log(data)

    let options = data.map((d) => ({
        label: d.name,
        value: d.id
    }))

    const { t } = useTranslation();

    return <>
        <Select
            placeholder={t('common.machines')}
            allowClear
            mode={mode == "multiple" ? mode : undefined}
            options={options}
            value={value}
            style={{ width: "100%", "minWidth": "150px" }}
            disabled={disabled}
            onChange={onChange}

        />
    </>
}